import $ from 'jquery';
import 'what-input';
import './libraries/hoverintent.min.js';
import './components/oembed.js';

import initAnchorLinks from './libraries/anchor-links';
import initLinkContainer from './libraries/link-container';
import initImpactStats from '../blocks/impact-stats/js/impact-stats.js';
import initAccordion from './modules/init-accordion.js';
import initTabModules from './modules/init-tab-modules.js';
import initQuoteSliderSplide from '../blocks/quote-slider/js/init-splide';
import initStandardCarouselSplide from '../blocks/standard-carousel/js/init-splide';

window.$ = window.jQuery = $;

$(() => {
	document.documentElement.style.visibility = 'visible';
	$('body').addClass('document-ready');

	initAnchorLinks();
	initLinkContainer();
	initAccordion();
	initImpactStats();
	initTabModules();
	initQuoteSliderSplide();
	initStandardCarouselSplide();
});
